/**
 * assets/pll-quick-add.js
 */
(function () {
  'use strict';

  window.pllMoney = window.pllMoney || function (cents) {
    var n = parseFloat(cents);
    return isNaN(n) ? '' : '$' + (n / 100).toFixed(2).replace(/\.00$/, '');
  };

  window.pllEsc = window.pllEsc || function (s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  };

  window.pllAddToCart = window.pllAddToCart || async function (vid, onSuccess, onError) {
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
      });
      if (res.ok) {
        var cart = await (await fetch('/cart.js')).json();
        document.querySelectorAll('.pll-bag-btn__count').forEach(function (el) {
          el.textContent = '(' + cart.item_count + ')';
        });
        if (onSuccess) onSuccess();
      } else {
        var err = await res.json();
        if (onError) onError(err.description || 'Unavailable');
      }
    } catch (ex) { if (onError) onError('Error'); }
  };

  var _prodCache = {};
  window.pllGetProd = window.pllGetProd || async function (handle) {
    if (!_prodCache[handle])
      _prodCache[handle] = await (await fetch('/products/' + handle + '.js')).json();
    return _prodCache[handle];
  };

  window.pllQuickAdd = window.pllQuickAdd || async function (e, btn) {
    e.preventDefault(); e.stopPropagation();
    var vid = btn.dataset.vid; if (!vid) return;
    var orig = btn.textContent; btn.textContent = 'Adding…'; btn.disabled = true;
    await window.pllAddToCart(vid,
      function () { btn.textContent = '✓ Added!'; setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000); },
      function (msg) { btn.textContent = msg; btn.disabled = false; setTimeout(function () { btn.textContent = orig; }, 2500); }
    );
  };

  function pllResetPicker(vc) {
    var fe = vc.querySelector('.pll-vc-from'); if (fe) fe.style.display = '';
    var pe = vc.querySelector('.pll-vc-price');
    if (pe && vc.dataset.fromPrice) { pe.textContent = vc.dataset.fromPrice; pe.style.color = ''; }
    vc.querySelectorAll('.pll-vc-p.sel').forEach(function (p) { p.classList.remove('sel'); });
    var ab = vc.querySelector('.pll-vc-add');
    if (ab) { ab.disabled = true; ab.textContent = 'Select options'; delete ab.dataset.vid; }
  }

  function pllCloseAllPickers() {
    document.querySelectorAll('.pll-vc.open').forEach(function (vc) {
      vc.classList.remove('open'); pllResetPicker(vc);
      var card = vc.closest('.pll-pc');
      if (card) { var qb = card.querySelector('.pll-pc-quick--multi'); if (qb) qb.textContent = 'Quick add'; }
    });
  }

  window.pllCloseVc = function (e, btn) {
    e.stopPropagation();
    var vc = btn.closest('.pll-vc'); if (!vc) return;
    vc.classList.remove('open'); pllResetPicker(vc);
    var card = vc.closest('.pll-pc');
    if (card) { var qb = card.querySelector('.pll-pc-quick--multi'); if (qb) qb.textContent = 'Quick add'; }
  };

  window.pllShowPicker = async function (e, btn) {
    e.preventDefault(); e.stopPropagation();
    if (window.innerWidth < 990) { pllOpenSheet(btn); return; }
    var card = btn.closest('.pll-pc'), vc = card ? card.querySelector('.pll-vc') : null;
    if (!vc) return;
    if (vc.classList.contains('open')) { pllCloseAllPickers(); return; }
    pllCloseAllPickers();
    if (!vc.dataset.loaded) {
      btn.textContent = '…';
      try {
        var handle = btn.dataset.handle ||
          (card.href && card.href.indexOf('/products/') > -1
            ? card.href.split('/products/')[1].split('?')[0].split('#')[0]
            : '');
        var prod = await window.pllGetProd(handle);
        var catEl = card.querySelector('.pll-pc-body .pll-pc-cat');
        var catText = catEl ? catEl.textContent.trim() : (prod.product_type || '');
        var prices = prod.variants.map(function (v) { return v.price; });
        var minP = Math.min.apply(null, prices), maxP = Math.max.apply(null, prices);
        var hasRange = minP !== maxP;
        var html = '<button type="button" class="pll-vc-close" onclick="pllCloseVc(event,this)">&times;</button>'
          + '<div class="pll-vc-head">'
          + (catText ? '<span class="pll-vc-cat">' + window.pllEsc(catText) + '</span>' : '')
          + '<div class="pll-vc-name-row"><span class="pll-vc-title">' + window.pllEsc(prod.title) + '</span>'
          + '<span class="pll-vc-price-wrap">'
          + (hasRange ? '<span class="pll-vc-from">From</span>' : '')
          + '<span class="pll-vc-price">' + window.pllMoney(minP) + '</span>'
          + '</span></div></div><div class="pll-vc-opts">';
        prod.options.forEach(function (opt, i) {
          html += '<div class="pll-vc-g"><span class="pll-vc-lbl">' + window.pllEsc(opt.name) + '</span><div class="pll-vc-ps">';
          opt.values.forEach(function (val) {
            html += '<button type="button" class="pll-vc-p" data-oi="' + i + '" data-v="' + window.pllEsc(val) + '" onclick="pllPickV(event,this)">' + window.pllEsc(val) + '</button>';
          });
          html += '</div></div>';
        });
        html += '</div><button type="button" class="pll-vc-add" disabled onclick="pllVcAdd(event,this)">Select options</button>';
        vc.innerHTML = html;
        vc.dataset.variants = JSON.stringify(prod.variants.map(function (v) {
          return { id: v.id, opts: v.options, avail: v.available, price: v.price };
        }));
        vc.dataset.nopt = prod.options.length;
        vc.dataset.hasRange = hasRange ? '1' : '';
        vc.dataset.fromPrice = window.pllMoney(minP);
        vc.dataset.loaded = '1';
      } catch (ex) { btn.textContent = 'Quick add'; return; }
    } else { pllResetPicker(vc); }
    btn.textContent = 'Quick add \u25b4';
    requestAnimationFrame(function () { requestAnimationFrame(function () { vc.classList.add('open'); }); });
  };

  window.pllPickV = function (e, pill) {
    e.stopPropagation();
    var vc = pill.closest('.pll-vc'), oi = pill.dataset.oi;
    vc.querySelectorAll('.pll-vc-p[data-oi="' + oi + '"]').forEach(function (p) { p.classList.remove('sel'); });
    pill.classList.add('sel');
    var n = parseInt(vc.dataset.nopt), sel = [];
    for (var i = 0; i < n; i++) {
      var p = vc.querySelector('.pll-vc-p[data-oi="' + i + '"].sel');
      sel.push(p ? p.dataset.v : null);
    }
    var allSel = sel.every(function (s) { return s !== null; });
    var ab = vc.querySelector('.pll-vc-add');
    var pe = vc.querySelector('.pll-vc-price'), fe = vc.querySelector('.pll-vc-from');
    if (!allSel) {
      if (fe && vc.dataset.hasRange === '1') fe.style.display = '';
      if (pe && vc.dataset.fromPrice) { pe.textContent = vc.dataset.fromPrice; pe.style.color = ''; }
      ab.disabled = true; ab.textContent = 'Select options'; delete ab.dataset.vid;
      return;
    }
    var variants = JSON.parse(vc.dataset.variants);
    var match = variants.find(function (v) { return v.opts.every(function (o, i) { return o === sel[i]; }); });
    if (fe) fe.style.display = 'none';
    if (match && match.avail) {
      if (pe) { pe.textContent = window.pllMoney(match.price); pe.style.color = ''; }
      ab.disabled = false; ab.textContent = 'Add to bag'; ab.dataset.vid = match.id;
    } else {
      if (pe) { pe.textContent = 'Unavailable'; pe.style.color = '#C4B4C4'; }
      ab.disabled = true; ab.textContent = 'Out of stock'; delete ab.dataset.vid;
    }
  };

  window.pllVcAdd = async function (e, btn) {
    e.stopPropagation();
    var vid = btn.dataset.vid; if (!vid || btn.disabled) return;
    var orig = btn.textContent; btn.textContent = 'Adding…'; btn.disabled = true;
    await window.pllAddToCart(vid,
      function () {
        btn.textContent = '✓ Added!';
        setTimeout(function () {
          var vc = btn.closest('.pll-vc');
          if (vc) { vc.classList.remove('open'); pllResetPicker(vc); pllCloseAllPickers(); }
        }, 900);
      },
      function (msg) { btn.textContent = msg; btn.disabled = false; setTimeout(function () { btn.textContent = orig; }, 2500); }
    );
  };

  if (!window._pllQAInit) {
    window._pllQAInit = true;
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.pll-vc') && e.target.closest('.pll-vc').classList.contains('open'))
        e.preventDefault();
    }, true);
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.pll-pc')) pllCloseAllPickers();
    });
  }

  var _bsO, _bsS, _bsBody, _bsAdd, _bsCat, _bsTitle, _bsPrice, _bsImg;

  function pllBsInit() {
    _bsO     = document.getElementById('pll-bs-overlay');
    _bsS     = document.getElementById('pll-bs');
    _bsBody  = document.getElementById('pll-bs-body');
    _bsAdd   = document.getElementById('pll-bs-add');
    _bsCat   = document.getElementById('pll-bs-cat');
    _bsTitle = document.getElementById('pll-bs-title');
    _bsPrice = document.getElementById('pll-bs-price');
    _bsImg   = document.getElementById('pll-bs-img');
    if (!_bsO || !_bsS) return;
    _bsAdd.addEventListener('click', async function () {
      var vid = _bsAdd.dataset.vid; if (!vid || _bsAdd.disabled) return;
      var orig = _bsAdd.textContent; _bsAdd.textContent = 'Adding…'; _bsAdd.disabled = true;
      await window.pllAddToCart(vid,
        function () { _bsAdd.textContent = '✓ Added!'; setTimeout(window.pllCloseSheet, 900); },
        function (msg) { _bsAdd.textContent = msg; _bsAdd.disabled = false; setTimeout(function () { _bsAdd.textContent = orig; }, 2500); }
      );
    });
    _bsO.addEventListener('click', window.pllCloseSheet);
    var _tY = 0;
    _bsS.addEventListener('touchstart', function (e) { _tY = e.touches[0].clientY; }, { passive: true });
    _bsS.addEventListener('touchend', function (e) { if (e.changedTouches[0].clientY - _tY > 60) window.pllCloseSheet(); }, { passive: true });
    window.addEventListener('resize', function () { if (window.innerWidth >= 990) window.pllCloseSheet(); }, { passive: true });
  }

  window.pllCloseSheet = function () {
    if (!_bsS) return;
    _bsS.classList.remove('open');
    _bsO.classList.remove('visible');
    setTimeout(function () { _bsO.classList.remove('open'); document.body.style.overflow = ''; }, 320);
  };

  function pllOpenSheet(btn) {
    if (!_bsS) { pllBsInit(); if (!_bsS) return; }
    var card = btn.closest('.pll-pc'); if (!card) return;
    var handle = btn.dataset.handle ||
      (card.href && card.href.indexOf('/products/') > -1
        ? card.href.split('/products/')[1].split('?')[0].split('#')[0]
        : '');
    var catEl  = card.querySelector('.pll-pc-body .pll-pc-cat');
    var nameEl = card.querySelector('.pll-pc-name');
    var prEL   = card.querySelector('.pll-pc-price');
    var imgEl  = card.querySelector('.pll-pc-inner img');
    _bsCat.textContent   = catEl  ? catEl.textContent.trim()  : '';
    _bsTitle.textContent = nameEl ? nameEl.textContent         : '';
    _bsPrice.textContent = prEL   ? prEL.textContent           : '';
    _bsPrice.style.color = '';
    _bsImg.innerHTML = '';
    if (imgEl) { var cl = imgEl.cloneNode(true); cl.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;'; _bsImg.appendChild(cl); }
    else { _bsImg.style.background = '#FFE8F3'; }
    _bsBody.innerHTML = '<div style="text-align:center;padding:28px 0;color:#8B6A8B;font-size:13px;">Loading options…</div>';
    _bsBody.dataset.variants = ''; _bsBody.dataset.nopt = '0';
    _bsAdd.disabled = true; _bsAdd.textContent = 'Select options'; delete _bsAdd.dataset.vid;
    _bsO.classList.add('open'); document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { _bsO.classList.add('visible'); _bsS.classList.add('open'); });
    window.pllGetProd(handle).then(function (prod) {
      var html = '';
      prod.options.forEach(function (opt, i) {
        html += '<div class="pll-bs-group"><span class="pll-bs-lbl">' + window.pllEsc(opt.name) + '</span><div class="pll-bs-pills">';
        opt.values.forEach(function (val) {
          html += '<button type="button" class="pll-bs-p" data-oi="' + i + '" data-v="' + window.pllEsc(val) + '" onclick="pllPickBS(event,this)">' + window.pllEsc(val) + '</button>';
        });
        html += '</div></div>';
      });
      _bsBody.innerHTML = html;
      _bsBody.dataset.variants = JSON.stringify(prod.variants.map(function (v) {
        return { id: v.id, opts: v.options, avail: v.available, price: v.price };
      }));
      _bsBody.dataset.nopt = prod.options.length;
      var avP = prod.variants.filter(function (v) { return v.available; }).map(function (v) { return v.price; });
      if (avP.length) { _bsPrice.textContent = 'From ' + window.pllMoney(Math.min.apply(null, avP)); _bsPrice.style.color = ''; }
    }).catch(function () {
      _bsBody.innerHTML = '<div style="color:#FF2D78;padding:12px 0;font-size:13px;">Unable to load options.</div>';
    });
  }

  window.pllPickBS = function (e, pill) {
    e.stopPropagation();
    var oi = pill.dataset.oi;
    _bsBody.querySelectorAll('.pll-bs-p[data-oi="' + oi + '"]').forEach(function (p) { p.classList.remove('sel'); });
    pill.classList.add('sel');
    var n = parseInt(_bsBody.dataset.nopt), sel = [];
    for (var i = 0; i < n; i++) {
      var p = _bsBody.querySelector('.pll-bs-p[data-oi="' + i + '"].sel');
      sel.push(p ? p.dataset.v : null);
    }
    var allSel = sel.every(function (s) { return s !== null; });
    if (!allSel) { _bsAdd.disabled = true; _bsAdd.textContent = 'Select options'; delete _bsAdd.dataset.vid; return; }
    var variants = JSON.parse(_bsBody.dataset.variants || '[]');
    var match = variants.find(function (v) { return v.opts.every(function (o, i) { return o === sel[i]; }); });
    if (match && match.avail) {
      _bsAdd.disabled = false; _bsAdd.textContent = 'Add to bag'; _bsAdd.dataset.vid = match.id;
      _bsPrice.textContent = window.pllMoney(match.price); _bsPrice.style.color = '';
    } else {
      _bsAdd.disabled = true; _bsAdd.textContent = match ? 'Out of stock' : 'Unavailable'; delete _bsAdd.dataset.vid;
      _bsPrice.textContent = 'Unavailable'; _bsPrice.style.color = '#C4B4C4';
    }
  };

  /* ── JS CARD BUILDER (recently-viewed + recs) ── */
  window.pllBuildCard = function (p, i) {
    var imgSrc = p.image || (p.images && p.images.length ? p.images[0].src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_400x$1$3') : '');
    /* No image — plain #FFE8F3 matching the pre-load placeholder colour site-wide */
    var imgHtml = imgSrc
      ? '<img src="' + window.pllEsc(imgSrc) + '" alt="' + window.pllEsc(p.title) + '" loading="lazy">'
      : '<div style="width:100%;height:100%;background:#FFE8F3;"></div>';
    var hasRange = p.price_max && p.price_max !== p.price;
    var isSingle = p.has_only_default_variant || (!hasRange && p.variants && p.variants.length === 1);
    var fvId = p.variant_id || (p.variants && p.variants[0] && p.variants[0].id);
    var quickBtn;
    if (p.available === false) {
      quickBtn = '<button type="button" class="pll-pc-quick" disabled>Sold out</button>';
    } else if (isSingle && fvId) {
      quickBtn = '<button type="button" class="pll-pc-quick" data-vid="' + fvId + '" onclick="pllQuickAdd(event,this)">Quick add</button>';
    } else {
      quickBtn = '<button type="button" class="pll-pc-quick pll-pc-quick--multi" data-handle="' + window.pllEsc(p.handle) + '" onclick="pllShowPicker(event,this)">Quick add</button>';
    }
    var ptype = p.type || p.product_type || '';
    var priceHtml = (p.compare_at_price && p.compare_at_price > p.price)
      ? '<span class="pll-pc-price sale">' + window.pllMoney(p.price) + '</span><span class="pll-pc-was">was <span>' + window.pllMoney(p.compare_at_price) + '</span></span>'
      : '<span class="pll-pc-price">' + window.pllMoney(p.price) + '</span>';
    return '<a href="' + (p.url || '/products/' + window.pllEsc(p.handle)) + '" class="pll-pc">'
      + '<div class="pll-pc-img"><div class="pll-pc-inner">' + imgHtml + '</div>' + quickBtn + '</div>'
      + '<div class="pll-pc-body">'
      + '<div class="pll-meta-row">'
      + (ptype ? '<span class="pll-pc-cat">' + window.pllEsc(ptype) + '</span>' : '<span></span>')
      + (hasRange ? '<span class="pll-from">From</span>' : '')
      + '</div>'
      + '<div class="pll-pc-title-row"><div class="pll-pc-name">' + window.pllEsc(p.title) + '</div>'
      + '<div class="pll-pc-price-col">' + priceHtml + '</div></div>'
      + '</div>'
      + '<div class="pll-vc"></div>'
      + '</a>';
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pllBsInit);
  else pllBsInit();

})();
